export const ipoReitId = '6';
